export default {
	methods: {
		formatDateLocal(date) {
			//converts js date and time to Central Time formats ex: 01/01/2022, 1:00:00 PM
			if (!date) return "";
			let newDate = new Date(date);
			return newDate.toLocaleString('en-US', { timeZone: 'America/Chicago' });
		},

		formatDate(date) {
			//takes date js date format and converts to standard format ex: 01/01/2022
			if (!date) return "";

			date = date.substring(0, 10);
			const [year, month, day] = date.split("-");
			return `${month}/${day}/${year}`;
		},

		parseDate(date) {
			//use with vuetify calander inputs
			if (!date) return null;
			const [month, day, year] = date.split("/");
			return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
		},

		// Get current date in Central Time (America/Chicago) - format: M/D/YY
		getCentralTimeDate() {
			const now = new Date();
			return now.toLocaleDateString('en-US', {
				timeZone: 'America/Chicago',
				month: 'numeric',
				day: 'numeric',
				year: '2-digit'
			});
		},

		// Get current time in Central Time (America/Chicago) - format: h:mm am/pm
		getCentralTime() {
			const now = new Date();
			return now.toLocaleTimeString('en-US', {
				timeZone: 'America/Chicago',
				hour: 'numeric',
				minute: '2-digit',
				hour12: true
			}).toLowerCase();
		},

		// Extract initials from a name string or return as-is if already initials
		extractInitials(nameOrInitials) {
			if (!nameOrInitials) return '';
			// If already 2-3 characters, assume it's initials
			if (nameOrInitials.length <= 3) return nameOrInitials.toUpperCase();
			// Split by space and take first char of each word (max 2)
			const parts = nameOrInitials.trim().split(/\s+/);
			if (parts.length >= 2) {
				return (parts[0][0] + parts[1][0]).toUpperCase();
			}
			// Single word - take first 2 characters
			return nameOrInitials.substring(0, 2).toUpperCase();
		},
	},
};
